export default "__VITE_ASSET__xM4Yk_he__"